export default __webpack_public_path__ + "static/media/img-guide-gt-popup-4-be_fr.22f18971.png";